<template>
    <form v-if="value">
        <div>Wekelijks elke</div>
        <ui5-select @change="value.day = $event.detail.selectedOption.value">
            <ui5-option
                :value="1"
                :selected="value.day == 1"
            >
                maandag
            </ui5-option>
            <ui5-option
                :value="2"
                :selected="value.day == 2"
            >
                dinsdag
            </ui5-option>
            <ui5-option
                :value="3"
                :selected="value.day == 3"
            >
                woensdag
            </ui5-option>
            <ui5-option
                :value="4"
                :selected="value.day == 4"
            >
                donderdag
            </ui5-option>
            <ui5-option
                :value="5"
                :selected="value.day == 5"
            >
                vrijdag
            </ui5-option>
        </ui5-select>
        <div>
            <text-input
                type="number"
                min="1"
                step="1"
                v-model="value.count"
            />
            <div
                v-if="getErrorFromValidator($v.value.count).length"
                class="error"
            >
                {{ getErrorFromValidator($v.value.count) }}
            </div>
        </div>
        <div>rit met chaffeur</div>
        <ui5-select
            @change="value.driverId = $event.detail.selectedOption.value"
        >
            <ui5-option
                v-for="driver in drivers"
                :value="driver.ID"
                :selected="driver.ID == value.driverId"
                :key="'driver.' + driver.ID"
            >
                {{ driver.name }}
            </ui5-option>
        </ui5-select>
        <div>en voertuig</div>
        <ui5-select
            @change="value.truckId = $event.detail.selectedOption.value"
        >
            <ui5-option
                v-for="truck in trucks"
                :value="truck.ID"
                :selected="truck.ID == value.truckId"
                :key="'truck.' + truck.ID"
            >
                {{ truck.name }}
            </ui5-option>
        </ui5-select>
        <slot />
    </form>
</template>

<script>
import { numeric, required, minValue } from 'vuelidate/lib/validators';
import ErrorHelper from './../../helpers/ErrorHelper';
import TextInput from '../TextInput';

export default {
    name: 'DeliveryRouteConfigForm',
    components: {
        TextInput,
    },
    props: ['value', 'trucks', 'drivers'],
    watch: {
        value() {
            this.$emit('input', this.value);
        },
    },
    methods: {
        getErrorFromValidator:
            ErrorHelper.getErrorFromValidatorWithoutDirtyCheck,
    },
    validations() {
        return {
            value: {
                count: {
                    required,
                    numeric,
                    minValue: minValue(1),
                },
            },
        };
    },
};
</script>
